<template>
    <modal id="salary-receipt-create-modal"
           size="large"
           v-model="showModal"
           :title="$fieldTitle('add', 'receipt', true)"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">

        <form ref="form" :data-url="`${TENANT_BASE_URL}app/salary-receipt`" @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        type="date"
                        :label="$t('payment_date')"
                        v-model="formData.payment_date"
                        :placeholder="formData.payment_date ? $placeholder('date') : this.$t('not_added_yet')"
                        :error-message="$errorMessage(errors, 'payment_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('payment_method')"
                        type="select"
                        v-model="formData.payment_method"
                        :error-message="$errorMessage(errors, 'payment_method')"
                        :list="[
                            {id: 'banking', value: $t('banking')},
                            {id: 'cash', value: $t('cash')},
                            {id: 'both', value: $t('both')},
                        ]"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('authorization')"
                        type="select"
                        v-model="formData.authorization"
                        :error-message="$errorMessage(errors, 'authorization')"
                        :list="[
                            {id: 0, value: $t('no')},
                            {id: 1, value: $t('yes')},
                        ]"
                    />
                </div>
                <div v-if="formData.authorization == 1" class="col-md-6">
                    <app-form-group
                        :label="$t('password')"
                        type="text"
                        :placeholder="$placeholder('password', '')"
                        v-model="formData.password"
                        :error-message="$errorMessage(errors, 'password')"
                    />
                </div>
                <div v-if="formData.authorization == 1" class="col-md-6">
                    <app-form-group
                        :label="$t('collection_authorization')"
                        type="text"
                        :placeholder="$placeholder('collection_authorization', '')"
                        v-model="formData.collection_authorization"
                        :error-message="$errorMessage(errors, 'collection_authorization')"
                    />
                </div>
                <div v-if="formData.authorization == 1" class="col-md-12">
                    <app-form-group
                        :label="$t('document')"
                        type="file"
                        v-model="document"
                        :multiple="true"
                        :placeholder="$placeholder('document', '')"
                        :file-label="$placeholder('document', '')"
                        :error-message="$errorMessage(errors, 'document.0')"
                    />
                </div>
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('note')"
                        :placeholder="$textAreaPlaceHolder('note')"
                        v-model="formData.note"
                        :text-area-rows="4"
                        :error-message="$errorMessage(errors, 'note')">
                    </app-form-group>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../common/Helper/Support/FormHelper";
import {formatDateForServer} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    name  : "SalaryReceiptCreateModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        rowData: {},
    },
    data() {
        return {
            TENANT_BASE_URL,
            document: [],
            formData: {
                authorization: 0
            },
        }
    },
    methods: {
        submitData() {
            this.loading   = true
            const url      = this.$refs.form.dataset["url"];
            const formData = formDataAssigner(new FormData, this.formData);

            formData.set('salary_id', this.rowData.id)
            formData.set('payment_date', formatDateForServer(this.formData.payment_date))

            this.document.forEach(file => formData.append('document[]', file))

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.formData = {};
            $('#salary-receipt-create-modal').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'salary-sheet-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            const receipt = this.rowData.receipt;
            if (receipt) {
                this.formData.payment_date = receipt.payment_date;
                this.formData.payment_method = receipt.payment_method;
                this.formData.authorization = receipt.authorization;
                this.formData.note = receipt.note;
            }
        },
    },
}
</script>
